import styled from 'styled-components';
import { NumberInput as NumberInputComponent } from '@prisjakt/ui-inputs';
import { media, colors } from '@prisjakt/ui-base';

export const Section = styled.div({
  marginTop: '20px',
  marginBottom: '20px',
  paddingTop: '20px',
  borderTop: 'solid 1px #eee',
  width: '100%',

  '.pj-ui-radio': {
    '&:not(:first-of-type)': {
      marginTop: '10px',
    },
  },
});

export const NumberInput = styled(NumberInputComponent)(
  {
    '&&': {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: '20px',

      '.pj-ui-text-input--label-text': {
        whiteSpace: 'nowrap',
        marginRight: '10px',
      },

      input: {
        width: 'auto',
        minWidth: '100px',
      },
    },
  },

  media.smallOnly({
    '&&': {
      input: {
        fontSize: '16px',
      },
    },
  })
);

export const LoginPromoButton = styled.div({});

export const Error = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  p: {
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    marginBottom: 0,
  },

  strong: {
    borderBottom: 'dotted 1px #000',
  },

  svg: {
    marginRight: '10px',

    path: {
      fill: colors.mediumGray1,
    },
  },

  button: {
    cursor: 'pointer',
  },
});
